// Copyright (C) 2026, Lifefinder Systems International AB

import { useMapEvents } from 'react-leaflet';

export interface PositionPickerLayerProps {
  onPick: (latlng: [number, number]) => void;
}

/**
 * Invisible Leaflet layer that captures a single map click and reports
 * the coordinate. Used by AreaEditor when the user is picking a custom
 * device position within an area.
 */
const PositionPickerLayer: React.FC<PositionPickerLayerProps> = ({ onPick }) => {
  useMapEvents({
    click(e) {
      onPick([e.latlng.lat, e.latlng.lng]);
    },
  });
  return null;
};

export default PositionPickerLayer;
